import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=dbf61496&scoped=true&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&id=dbf61496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf61496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbf61496')) {
      api.createRecord('dbf61496', component.options)
    } else {
      api.reload('dbf61496', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=dbf61496&scoped=true&", function () {
      api.rerender('dbf61496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/sale/Create.vue"
export default component.exports